import { withTheme } from "@mui/styles";
import CustomerPortalContainer from "./CustomerPortalContainer";
import CustomerPortalStore from "./CustomerPortalStore";

export default CustomerPortalStore(withTheme(CustomerPortalContainer));